import React, { FC } from 'react';
import { Text } from 'react-native';

import ColorWrapper, { WithColor } from '@styles/colors';
import { scale } from '@components/frame';
import { font } from '@styles/fonts';
import Svg from '@styles/icons/svg';
import { SimpleOnPress } from '@interfaces/base';
import { DashboardScope } from '@api/domain/types';
import type { DashboardResult } from '@api/domain/types';

import DashboardRowWrapper from '@v2/pages/dashboard/common/components/DashboardRowWrapper';
import DashboardRowImage from '@v2/pages/dashboard/common/components/DashboardRowImage';
import { rowHasImage } from '@v2/pages/dashboard/common/helpers';
import type { WithBorderRadiusConfig } from '@v2/pages/dashboard/common/types/rows';
import { ROW_LAYOUT } from '@v2/pages/dashboard/common/constants/rows';

import DashboardListBar from '@v2/pages/dashboard/common/components/DashboardList/components/DashboardListBar';
import { DashboardListBarVariant } from '@v2/pages/dashboard/common/components/DashboardList/components/DashboardListBar/types';

import { useManageDashboardListActualRow } from './hooks/useManageDashboardListActualRow';
import {ACTUAL_ROW_CONFIG} from './constants';

interface DashboardListActualRowProps extends WithColor, SimpleOnPress, WithBorderRadiusConfig {
  scope: DashboardScope;
  item: DashboardResult;
  maxSeconds: number | null;
  testID?: string;
}

const DashboardListActualRow: FC<DashboardListActualRowProps> = ({
  C, scope, item, maxSeconds, onPress, borderRadiusConfig, testID,
}) => {
  const { seconds, valueText, name } = useManageDashboardListActualRow({ item });

  return (
    <DashboardRowWrapper
      scope={scope}
      borderRadiusConfig={borderRadiusConfig}
      onPress={onPress}
      testID={testID}
    >
      {rowHasImage(scope) && (
        <DashboardRowImage imageHash={item.imageHash} imageData={item.imageData} />
      )}
      <Text
        style={[font[ROW_LAYOUT.name.fontType], { color: C('Label/Light/Primary'), minWidth: scale(ACTUAL_ROW_CONFIG), marginHorizontal: scale(12) }]}
        numberOfLines={1}
      >
        {name}
      </Text>
      <DashboardListBar
        seconds={seconds}
        maxSeconds={maxSeconds}
        variant={DashboardListBarVariant.Actual}
        valueText={valueText}
      />
      <Svg icon="chevronRight" color="Label/Light/Quinary" width={scale(ROW_LAYOUT.chevron.size)} height={scale(ROW_LAYOUT.chevron.size)} />
    </DashboardRowWrapper>
  );
};

export default ColorWrapper(DashboardListActualRow);
